import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { OFFICES, CONTACT_EMAIL } from "@/components/site/SiteLayout";
import { PageHero } from "@/pages/site/ContentPage";
import { EnquiryForm } from "@/components/site/EnquiryForm";

export default function Contact() {
  return (
    <div>
      <PageHero image="plant" eyebrow="Contact" title="Talk to CCMIntel" subtitle="Questions about dashboards, reports, consulting, technology transfer or plant advisory — we'll respond within one business day." />
      <div className="max-w-[1100px] mx-auto px-4 md:px-8 py-14 grid lg:grid-cols-[1fr_320px] gap-10">
        <EnquiryForm />
        <div className="space-y-4">
          <div className="bg-[#0F172A] border border-slate-800 rounded-lg p-5 space-y-3" data-testid="contact-offices">
            <p className="font-mono text-xs uppercase tracking-widest text-[#F58B23]">Information about us</p>
            {OFFICES.map((o) => <p key={o} className="flex gap-2 text-sm text-slate-300"><MapPin className="h-4 w-4 text-[#03AB9E] shrink-0 mt-0.5" />{o}</p>)}
          </div>
          {[{ icon: Phone, t: "+91 89770 92264", h: "tel:+918977092264" }, { icon: MessageCircle, t: "WhatsApp us", h: "https://wa.me/918977092264" }, { icon: Mail, t: CONTACT_EMAIL, h: `mailto:${CONTACT_EMAIL}` }].map(({ icon: Icon, t, h }) => (
            <a key={t} href={h} className="flex items-center gap-3 bg-[#0F172A] border border-slate-800 rounded-lg p-5 hover:border-[#03AB9E]" data-testid={`contact-link-${h.split(":")[0]}`}>
              <Icon className="h-5 w-5 text-[#03AB9E]" /><span className="text-sm">{t}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
